import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"

//Include Both Helperith needed methods

 
import {
  postFakeForgetPwd,

} from "../../../helpers/backend_helper";



export const userForgetPassword = (user : any, history : any) => async (dispatch : any) => {
  try {
      let response;
      {
          response = postFakeForgetPwd(
              user.email
          )
      }

      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(
              "Reset link are sended to your mailbox, check there first"
          ))
      }
  } catch (forgetError: any) {
      dispatch(userForgetPasswordError(
        forgetError?.message || 'Failed to send reset link. Please try again.'
      ))
  }
}